import { Box, Heading, Icon, Text, VStack } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';
import { Surface, SurfaceProps } from './Surface';

interface EmptyStateProps extends Omit<SurfaceProps, 'children' | 'title'> {
  icon?: ReactElement;
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'card',
  py = '8',
  ...props
}: EmptyStateProps) {
  return (
    <Surface variant={variant} py={py} px="6" {...props}>
      <VStack gap="3" textAlign="center">
        {icon ? (
          <Box layerStyle="iconTile" boxSize="10">
            <Icon boxSize="5">{icon}</Icon>
          </Box>
        ) : null}
        {title ? (
          <Heading as="h2" size="sm" fontWeight="700" color="ui.text.primary" textWrap="balance">
            {title}
          </Heading>
        ) : null}
        {description ? (
          <Text
            fontSize="sm"
            color="ui.text.secondary"
            maxW="md"
            lineHeight="1.55"
            textWrap="pretty"
          >
            {description}
          </Text>
        ) : null}
        {action}
      </VStack>
    </Surface>
  );
}
